module.exports = __webpack_public_path__ + "img/protese.44adfa3a.png";